import React, { useState } from "react";
import { Segment, Header, Grid } from "semantic-ui-react";
import useInspection from "../../../../hooks/inspections/useInspection";

interface InspectionPanelSectionsNavigationProps {
  id: number | string;
  onSelectSection?: (id: string) => void;
}
export default function InspectionPanelSectionsNavigation({
  id,
  onSelectSection = () => {},
}: InspectionPanelSectionsNavigationProps) {
  const { inspectionQuery } = useInspection({ id: id });

  const [selectedSectionId, setSelectedSectionId] = useState<string | null>(null);
  const sections = inspectionQuery.data?.data.attributes.sections;

  const handleSectionClick = (id: string) => {
    return () => {
      const selected = id === selectedSectionId;
      if (selected) {
        unSelectSection();
      } else {
        selectSection(id);
      }
    };
  };

  const selectSection = (id: string) => {
    setSelectedSectionId(id);
    onSelectSection(id);
  };

  const unSelectSection = () => {
    setSelectedSectionId(null);
  };

  return (
    <Segment basic>
      <Header sub className='subText tw-text-base'>
        Sections
      </Header>
      <Grid className='tw-my-2'>
        {sections?.map((section) => {
          const sectionId = section.data.id;
          const selected = sectionId === selectedSectionId;

          const color = selected ? "tw-border-black tw-text-black" : "tw-border-[#d1d5db] tw-text-[#d1d5db]";

          return (
            <Grid.Row
              key={sectionId}
              onClick={handleSectionClick(section.data.id)}
              className='tw-mx-1 tw-ml-2 tw-px-2 tw-py-0 hover:tw-cursor-pointer'
            >
              <h4 className={`tw-border-y-0 tw-border-l-2 tw-border-r-0 tw-border-solid tw-px-4 tw-py-6 ${color}`}>
                {section.data.attributes.title}
              </h4>
            </Grid.Row>
          );
        })}
      </Grid>
    </Segment>
  );
}
